import * as React from 'react';
import { AiOutlineControl } from 'react-icons/ai';
import { CommandCenterButton, FilterCountBoxSmall } from './styles';

interface Props {
  filterCount: number;
  onClick: () => void;
  // Shorter height (28px) so it lines up with the top quick-filter bar's segmented controls.
  compact?: boolean;
  className?: string;
}

/**
 * The "Filters" button that opens the Command Center. Shared so it can live next to the view
 * dropdown on mobile and inside the top quick-filter bar on desktop while staying identical.
 */
export default function FiltersButton({ filterCount, onClick, compact, className }: Props) {
  return (
    <CommandCenterButton
      onClick={onClick}
      className={className}
      style={compact ? { height: 28 } : undefined}
    >
      <span className="flex items-center">
        {filterCount > 0 && (
          <FilterCountBoxSmall className="flex items-center justify-center p-0">
            {filterCount}
          </FilterCountBoxSmall>
        )}
      </span>
      <AiOutlineControl />
      <span className="ml-1.5 text-xs font-bold">Filters</span>
    </CommandCenterButton>
  );
}
